// lib/client/sessionActions.js
'use client';

import { clearCache } from './interactionCache';
import { clearQueue } from './offlineQueue';

export async function logout() {
  // Clear interaction cache and offline queue
  clearCache();
  clearQueue();

  try {
    await fetch('/api/auth/logout', { method: 'POST', cache: 'no-store' });
  } catch {
    // Best-effort; continue to visitor logout which clears cookies + redirects.
  }
  window.location.assign('/auth/logout');
}

export async function refreshSession() {
  await fetch('/api/auth/refresh', { method: 'POST', cache: 'no-store' });
  location.reload();
}
